module.exports = __webpack_public_path__ + "static/media/filter.9d74bd12.svg";